import { InfiniteData } from "@tanstack/react-query";

import {
  AccountsMsSearchSupportUsersQuery,
  AccountsMsSearchSupportUsersRequestSortField,
  AccountsMsSearchSupportUsersResponseDataProfile,
  AccountsMsSearchSupportUsersResponseDataStatus,
} from "@/api/graphql/types/graphql.ts";
import {
  FE_SUPPORT_USER_PROFILES,
  FeSupportUser,
  FeSupportUserProfile,
  FeSupportUserStatus,
} from "@/types/agents.ts";

export const fromApiSupportUsersToFeSupportUsers = (
  queryResponse?: InfiniteData<AccountsMsSearchSupportUsersQuery | undefined>,
): FeSupportUser[] => {
  if (!queryResponse || !queryResponse.pages) {
    return [];
  }

  return queryResponse.pages.reduce<Array<FeSupportUser>>(
    (acc, curr) => [
      ...acc,
      ...(curr?.AccountsMsSearchSupportUsers.data || []).map<FeSupportUser>(
        (user): FeSupportUser => ({
          id: user.id,
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
          igg: user.AccessIdData?.igg || "",
          jobTitle: user?.jobTitle || "",
          updatedAt: user.AccessIdData?.lastAccessTs || "",
          createdTs: user.createdTs,
          accountProfile: mapSupportUserProfile(user.profile),
          status: mapSupportUserStatus(user.status),
          hasImpersonateRight: user.rights?.includes("IMPERSONATE") || false,
        }),
      ),
    ],
    [],
  );
};

export const getApiSearchSupportUsersRequestSortField = (
  sortableField: keyof FeSupportUser,
): AccountsMsSearchSupportUsersRequestSortField | null => {
  if (sortableField === "id") {
    return AccountsMsSearchSupportUsersRequestSortField.Id;
  } else {
    return null;
  }
};

export const getApiSearchSupportUsersRequestSortFields = (
  sortableFields: (keyof FeSupportUser)[],
): AccountsMsSearchSupportUsersRequestSortField[] =>
  sortableFields.reduce<AccountsMsSearchSupportUsersRequestSortField[]>(
    (acc, curr) => {
      const mappedKey = getApiSearchSupportUsersRequestSortField(curr);

      if (mappedKey !== null) {
        acc.push(mappedKey);
      }

      return acc;
    },
    [],
  );

function mapSupportUserProfile(
  profile?: AccountsMsSearchSupportUsersResponseDataProfile,
): FeSupportUserProfile {
  switch (profile) {
    case AccountsMsSearchSupportUsersResponseDataProfile.Agent:
      return FE_SUPPORT_USER_PROFILES.agent;
    case AccountsMsSearchSupportUsersResponseDataProfile.SuperAgent:
      return FE_SUPPORT_USER_PROFILES.superAgent;
    case AccountsMsSearchSupportUsersResponseDataProfile.ProfileUnknown:
    default:
      return FE_SUPPORT_USER_PROFILES.profileUnknown;
  }
}

function mapSupportUserStatus(
  status?: AccountsMsSearchSupportUsersResponseDataStatus,
): FeSupportUserStatus {
  switch (status) {
    case AccountsMsSearchSupportUsersResponseDataStatus.SupportUserDisabled:
      return FeSupportUserStatus.supportUserDisabled;
    case AccountsMsSearchSupportUsersResponseDataStatus.SupportUserEnabled:
      return FeSupportUserStatus.supportUserEnabled;
    case AccountsMsSearchSupportUsersResponseDataStatus.SupportUserInviting:
      return FeSupportUserStatus.supportUserInviting;
    case AccountsMsSearchSupportUsersResponseDataStatus.StatusUnknown:
    default:
      return FeSupportUserStatus.statusUnknown;
  }
}
